"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var styles = {
  dividerLine: {
    marginTop: function marginTop(_ref) {
      var spacing = _ref.spacing;
      return spacing(6);
    },
    marginBottom: function marginBottom(_ref2) {
      var spacing = _ref2.spacing;
      return spacing(2);
    }
  },
  gridContainer: {
    justifyContent: 'center'
  },
  boxButton: {
    display: 'flex',
    marginTop: 0.5,
    flexDirection: 'row'
  }
};

var StartBulkCreate = function StartBulkCreate(_ref3) {
  var onBulkCreate = _ref3.onBulkCreate;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3
  }, /*#__PURE__*/_react.default.createElement(_material.Divider, {
    sx: styles.dividerLine
  }, /*#__PURE__*/_react.default.createElement(_material.Chip, {
    label: "or"
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    sx: styles.gridContainer
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 0.5,
    sx: styles.boxButton
  }, /*#__PURE__*/_react.default.createElement(_ui.Button, {
    borderColor: "divider",
    onClick: onBulkCreate,
    "data-testid": "GiftingFlow.RecipientsDetails.BulkUploadList"
  }, "Bulk upload a list"))));
};

var _default = StartBulkCreate;
exports.default = _default;